module.exports = __webpack_public_path__ + "img/tooltip.a05edca1.svg";